{
  "Automatic ({language})": "Automático ({language})",
  "Language": "Idioma",
  "Cancel": "Cancelar",
  "OK": "Aceptar",
  "Ok": "Aceptar",
  "Okay": "Aceptar",
  "Yes": "Sí",
  "No": "No",
  "Save": "Guardar",
  "Saved": "Guardado",
  "Saving...": "Guardando...",
  "Saving…": "Guardando…",
  "Delete": "Eliminar",
  "Remove": "Quitar",
  "Edit": "Editar",
  "Change": "Cambiar",
  "Close": "Cerrar",
  "Done": "Listo",
  "Back": "Atrás",
  "Next": "Siguiente",
  "Continue": "Continuar",
  "Skip": "Omitir",
  "Retry": "Reintentar",
  "Try again": "Intentar de nuevo",
  "Please try again.": "Inténtalo de nuevo.",
  "Please try again": "Inténtalo de nuevo",
  "Something went wrong": "Algo salió mal",
  "Something went wrong. Please try again.": "Algo salió mal. Inténtalo de nuevo.",
  "Error": "Error",
  "Loading...": "Cargando...",
  "Loading…": "Cargando…",
  "Share": "Compartir",
  "Copy": "Copiar",
  "Copy link": "Copiar enlace",
  "Copied": "Copiado",
  "Copied!": "¡Copiado!",
  "Link copied": "Enlace copiado",
  "Open": "Abrir",
  "Restore": "Restaurar",
  "Learn more": "Más información",
  "More": "Más",
  "Help": "Ayuda",
  "Settings": "Configuración",
  "Open Settings": "Abrir Configuración",
  "Profile": "Perfil",
  "Email": "Correo electrónico",
  "Password": "Contraseña",
  "Name": "Nombre",
  "Title": "Título",
  "Location": "Ubicación",
  "Date and time": "Fecha y hora",
  "Privacy": "Privacidad",
  "Embed": "Embed",
  "Branding": "Marca",
  "Logo": "Logotipo",
  "Guestbook": "Libro de visitas",
  "Fundraising": "Recaudación de fondos",
  "Pricing": "Precios",
  "Plans": "Planes",
  "EventLive Plans": "Planes de EventLive",
  "My Events": "Mis eventos",
  "Event link": "Enlace del evento",
  "Event title": "Título del evento",
  "Go Live": "Transmitir en vivo",
  "Watch Live": "Ver en vivo",
  "Live only": "Solo en vivo",
  "Start free test": "Iniciar prueba gratis",
  "Free test": "Prueba gratis",
  "Unlock event": "Desbloquear evento",
  "Unlock": "Desbloquear",
  "Sell Tickets": "Vender boletos",
  "Video Wall": "Muro de videos",
  "Manage Video": "Administrar video",
  "Upload video": "Subir video",
  "What's new": "Novedades",
  "What's New": "Novedades",
  "Camera": "Cámara",
  "Required": "Obligatorio",
  "Terms": "Términos",
  "Monthly": "Mensual",
  "Unlimited": "Ilimitado",
  "Not found": "No encontrado",
  "Not signed in": "No has iniciado sesión",
  "Please sign in again.": "Vuelve a iniciar sesión.",
  "Too many requests. Please wait a moment and try again.": "Demasiadas solicitudes. Espera un momento e inténtalo de nuevo.",
  "Welcome to EventLive": "Te damos la bienvenida a EventLive",
  "Today": "Hoy",
  "Tomorrow": "Mañana",
  "Yesterday": "Ayer",
  "MMM D, YYYY": "D MMM YYYY",
  "MMM D": "D MMM",
  "h:mm A": "h:mm a",
  "h:mm a": "h:mm a",
  "Test Event": "Evento de prueba"
}
